{
  "FormEngineNavigationElement": {
    "title": "Navigation"
  },
  "mask": {
    "FormEngineNavigationElement": {
      "groupTitle": "Navigation",
      "datasource": "Artikel",
      "datasourceExpressions": "Artikelfilter"
    }
  }
}